module.exports = __webpack_public_path__ + "img/companion.0da2d32c.png";